import { createContext, PropsWithChildren, useContext } from "react"

import { InitHandlers, InitValues, useInitSdk } from "modules/Call/common/hooks"

const Context = createContext<[InitValues, InitHandlers] | null>(null)

export function InitCallProvider({ children }: PropsWithChildren<unknown>) {
    const [initValue, initHandlers] = useInitSdk()
    return <Context.Provider value={[initValue, initHandlers]}>{children}</Context.Provider>
}

export function useInitCallProvider() {
    return useContext(Context) as [InitValues, InitHandlers]
}
